export default __webpack_public_path__ + "static/media/5.82d07b3a.jpg";